<div id="app">
  <wbaHeader></wbaHeader>
  <app-mobil-ladeanzeige *ngIf="loadingOverlay"></app-mobil-ladeanzeige>
  <div
    id="app-content"
    [class.hideContent]="loadingOverlay">
    <router-outlet></router-outlet>
  </div>
  <wbaFooter></wbaFooter>
</div>
